// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Header from "../components/Header.js";
import * as Gatsby from "gatsby";
import * as Snippet from "../utils/Snippet.js";

import '../styles/index.scss';
;

import './Layout.scss'
;

var Raw = {};

var query = (graphql`
  query SiteMetadataQuery  {
    site  {
      siteMetadata  {
        title
        description
        github
      }
    }
  }
`);

function parse(value) {
  var value$1 = value.site;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.siteMetadata;
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2.title;
      var value$4 = value$2.description;
      var value$5 = value$2.github;
      tmp$1 = {
        title: !(value$3 == null) ? value$3 : undefined,
        description: !(value$4 == null) ? value$4 : undefined,
        github: !(value$5 == null) ? value$5 : undefined
      };
    }
    tmp = {
      siteMetadata: tmp$1
    };
  }
  return {
          site: tmp
        };
}

function serialize(value) {
  var value$1 = value.site;
  var site;
  if (value$1 !== undefined) {
    var value$2 = value$1.siteMetadata;
    var siteMetadata;
    if (value$2 !== undefined) {
      var value$3 = value$2.github;
      var github = value$3 !== undefined ? value$3 : null;
      var value$4 = value$2.description;
      var description = value$4 !== undefined ? value$4 : null;
      var value$5 = value$2.title;
      var title = value$5 !== undefined ? value$5 : null;
      siteMetadata = {
        title: title,
        description: description,
        github: github
      };
    } else {
      siteMetadata = null;
    }
    site = {
      siteMetadata: siteMetadata
    };
  } else {
    site = null;
  }
  return {
          site: site
        };
}

function serializeVariables(param) {
  
}

function makeVariables(param) {
  
}

function makeDefaultVariables(param) {
  
}

var SiteMetadataQuery = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};

function Layout(Props) {
  var children = Props.children;
  var siteMetadataQueryResult = Gatsby.useStaticQuery(query);
  var site = Snippet.getException(Snippet.flatMap(siteMetadataQueryResult.site, (function (site) {
              return site.siteMetadata;
            })));
  var title = Snippet.getException(site.title);
  var github = Snippet.getException(site.github);
  return React.createElement("main", undefined, React.createElement(Header.make, {
                  title: title,
                  github: github
                }), React.createElement("section", {
                  className: "section"
                }, React.createElement("div", {
                      className: "container-fluid"
                    }, children)));
}

var make = Layout;

var $$default = Layout;

export {
  SiteMetadataQuery ,
  make ,
  $$default ,
  $$default as default,
  
}
/*  Not a pure module */
